<!-- <h1 mat-dialog-title>Confirm</h1>
<div mat-dialog-content>{{confirmMessage}}</div>
<div mat-dialog-actions>
  <button mat-button style="color: #fff;background-color: #153961;" (click)="dialogRef.close(true)">Confirm</button>
  <button mat-button (click)="dialogRef.close(false)">Cancel</button>
</div> -->


<h2 mat-dialog-title class="bgDialogHeader text-center">Confirm <div class="pull-right">
    <a class="boxclose" (click)="dialogRef.close(0)"></a>
  </div>
</h2>
<mat-dialog-content class="">
  <nb-card>
    <nb-card-body>
      <div>
        <h3>{{confirmMessage}}</h3> <br /><br />
      </div>
      <button (click)="dialogRef.close(2)" class="btn btn-success btn-semi-round btn-demo pull-right bgBlue">
        No
      </button>

      <button (click)="dialogRef.close(1)"
        class="btn btn-success btn-semi-round  mr-4-per btn-demo  pull-right  bgBlue">
        Yes
      </button>
    </nb-card-body>
  </nb-card>
</mat-dialog-content>